define.alias("shared/components/shared/profile-categorization/rewards-steps/report", "calendar/components/shared/profile-categorization/rewards-steps/report");